var SearchPageEnum = /* @__PURE__ */ ((SearchPageEnum2) => {
  SearchPageEnum2["SEARCH_PAGE_TITLE"] = "search-page--title";
  SearchPageEnum2["SEARCH_PAGE_SEE_MORE"] = "search-page--see-more";
  SearchPageEnum2["SEARCH_PAGE_TELEMED_TITLE"] = "search-page--telemed-title";
  SearchPageEnum2["SEARCH_PAGE_TELEMED_SEE_MORE"] = "search-page--telemed-see-more";
  SearchPageEnum2["SEARCH_PAGE_EMPTY_STATE"] = "empty-state-section--search-schedule-empty-state";
  SearchPageEnum2["SEARCH_HEADER"] = "search-header";
  SearchPageEnum2["SEARCH_HEADER_LOADING"] = "search-header-loading";
  SearchPageEnum2["SEARCH_SCHEDULES"] = "search-schedules";
  SearchPageEnum2["SEARCH_CARD_LOADING"] = "search-card-loading";
  SearchPageEnum2["SEARCH_NOT_FOUND"] = "search-not-found";
  return SearchPageEnum2;
})(SearchPageEnum || {});
export {
  SearchPageEnum
};
